import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import AddUser from "./add-user";
import { makeStyles } from "@material-ui/core/styles";
import apiRequest from "../common/api-request";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import Button from "@material-ui/core/Button";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import Backdrop from "@material-ui/core/Backdrop";
import { CircularProgress } from "@material-ui/core";
import customLocalStorage from "../common/local-storage";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(1, 1),
  },
  paper: {
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(1),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
}));

const Users = (props) => {
  const { handleLogOut } = props;
  const classes = useStyles();
  const initialState = {
    allUsers: [],
    userRoles: [],
    partners: [],
    action: "Close",
    user: {},
    addAnother: false,
    addAnother: false,
    displaySnackBar: false,
    snackBarMessage: "",
    snackBarautoHideDuration: 2000, //milliseconds
    snackBarVerticalPosition: "top",
    snackBarHorizontalPosition: "right",
    snackBarSeverity: "info",
    loading: false,
  };

  const [state, setState] = useState(initialState);

  const {
    allUsers,
    action,
    user,
    userRoles,
    partners,
    addAnother,
    displaySnackBar,
    snackBarMessage,
    snackBarautoHideDuration,
    snackBarVerticalPosition,
    snackBarHorizontalPosition,
    snackBarSeverity,
    loading,
  } = state;

  const handleCloseSnackBar = () => {
    setState((prevState) => ({
      ...prevState,
      displaySnackBar: false,
      isLoading: false,
    }));
  };

  const handleLoader = (action) => {
    setState((prevState) => ({
      ...prevState,
      loading: action,
    }));
  };
  const showNotification = (msg, severity) => {
    if (severity.toLowerCase() === "error" && msg.search("401") !== -1) {
      handleLogOut({ msg: "Unauthorized", severity: "error" });
      return;
    }

    if (severity.toLowerCase() === "error" && msg.search("403") !== -1) {
      handleLogOut({ msg: "Token expired", severity: "error" });
      return;
    }

    setState((prevState) => ({
      ...prevState,
      displaySnackBar: true,
      snackBarMessage: msg,
      snackBarSeverity: severity,
    }));
  };

  const handleApiData = async (params) => {
    const { data, dataName, severity } = params;
    let snackBarMessage = "Success.";
    if (severity === "error") {
      snackBarMessage = data;
    }

    if (dataName === `addedUser`) {
      const userRole = customLocalStorage.decrypt("addedUserRole");
      const { id } = data;
      if (id) {
        await makeApiRequest({
          uri: `/users/roles/assign`,
          dataName: `updatedUserRole`,
          method: `post`,
          data: {
            user: id,
            role: userRole,
          },
        });
      }
    }

    if (severity !== "error" && Array.isArray(data || data?.results)) {
      setState((prevState) => ({
        ...prevState,
        [dataName]: data || data?.results,
        action: addAnother ? action : "Close",
        user: { updatePassword: true, is_admin: false, active: false },
      }));
    }

    if (
      severity !== "error" &&
      (dataName === `addedUser` || dataName === `updatedUser`)
    ) {
      (async () => {
        await makeApiRequest({
          uri: `/users/all`,
          dataName: `allUsers`,
          method: `get`,
          data: {},
        });
      })();
    }

    showNotification(snackBarMessage, severity);
  };

  const makeApiRequest = async (params) => {
    const { uri, dataName, method, data } = params;
    const requestParams = {
      url: `${process.env.REACT_APP_API_URL}${uri}`,
      data,
      callBack: handleApiData,
      method,
      dataName,
    };
    await apiRequest(requestParams);
  };

  const handleButtonClick = (action) => {
    setState((prevState) => ({
      ...prevState,
      action: addAnother && action === "Add" ? "Add" : action,
      user: action === `Close` ? {} : prevState.user,
    }));
  };

  const handleAddAnother = () => {
    setState((prevState) => ({
      ...prevState,
      addAnother: !prevState.addAnother,
    }));
  };

  const handleUserChange = async (user) => {
    const { action } = state;

    handleLoader(true);

    customLocalStorage.encrypt("addedUserRole", user?.userRole);

    if (action === `Add`) {
      await makeApiRequest({
        uri: `/auth/register`,
        dataName: `addedUser`,
        method: `post`,
        data: user,
      });
    }

    if (action === `Update`) {
      await makeApiRequest({
        uri: `/users/${user?.id}`,
        dataName: `updatedUser`,
        method: `put`,
        data: user,
      });
      await makeApiRequest({
        uri: `/users/roles/assign/${user?.userRole}`,
        dataName: `updatedUserRole`,
        method: `put`,
        data: {
          user: user?.id,
          role: user?.userRole,
        },
      });
    }
    handleLoader(false);
  };

  useEffect(() => {
    let initDataPromises = [];

    const getAllUsers = makeApiRequest({
      uri: `/users/all`,
      dataName: `allUsers`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllUsers];

    const getAllUserRoles = makeApiRequest({
      uri: `/users/roles/all`,
      dataName: `userRoles`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllUserRoles];

    const getAllPartners = makeApiRequest({
      uri: `/partners/all`,
      dataName: `partners`,
      method: `get`,
      data: {},
    });

    initDataPromises = [...initDataPromises, getAllPartners];

    (async () => {
      handleLoader(true);
      await Promise.all(initDataPromises)
        .then((results) => {
          //console.log({ results })
        })
        .catch((error) => console.log({ error }));
      handleLoader(false);
    })();
  }, []);

  const columns = [
    {
      label: "First Name",
      name: "first_name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Last Name",
      name: "last_name",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Email",
      name: "email",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Phone Number",
      name: "phone_number",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      label: "Partner",
      name: "partner",
      options: {
        filter: true,
        sort: true,
      },
    },
    // {
    //   label: "Role",
    //   name: "userrole",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value) => {
    //       return value?.roleName;
    //     },
    //   },
    // },
    // {
    //   label: "Is Admin",
    //   name: "is_admin",
    //   options: {
    //     filter: true,
    //     sort: true,
    //     customBodyRender: (value) => {
    //       return value ? "Yes" : "No";
    //     },
    //   },
    // },
    {
      label: "Active",
      name: "active",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return value ? "Yes" : "No";
        },
      },
    },
  ];

  const options = {
    jumpToPage: true,
    onRowClick: (_rowData, rowMeta) => {
      if (rowMeta?.dataIndex >= 0) {
        const user = { ...allUsers[rowMeta?.dataIndex] };
        setState((prevState) => ({
          ...prevState,
          user,
          action: "Update",
        }));
      }
    },
    onRowsDelete: (rowsDeleted) => {
      if (!window.confirm(`Are you sure you wish to delete this item?`))
        return false;
      if (Array.isArray(rowsDeleted?.data) && rowsDeleted?.data?.length > 0) {
        rowsDeleted.data.forEach((dataItem, index) => {
          const user = allUsers[dataItem.dataIndex];
          if (user?.id) {
            (async () => {
              await makeApiRequest({
                uri: `/users/${user?.id}`,
                dataName: `deletedCollectedWaste`,
                method: `delete`,
                data: {},
              });
              if (index === rowsDeleted.data.length - 1)
                await makeApiRequest({
                  uri: `/users/all`,
                  dataName: `allUsers`,
                  method: `get`,
                  data: {},
                });
            })();
          }
        });
      }
    },
  };

  return (
    <div>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress />
      </Backdrop>
      <Snackbar
        anchorOrigin={{
          vertical: snackBarVerticalPosition,
          horizontal: snackBarHorizontalPosition,
        }}
        open={displaySnackBar}
        onClose={handleCloseSnackBar}
        autoHideDuration={snackBarautoHideDuration}
        // message={snackBarMessage}
      >
        <Alert onClose={handleCloseSnackBar} severity={snackBarSeverity}>
          {snackBarMessage}
        </Alert>
      </Snackbar>
      {(action === "Add" || action === "Update") && (
        <AddUser
          handleButtonClick={handleButtonClick}
          action={action}
          user={user}
          handleUserChange={handleUserChange}
          userRoles={userRoles}
          partners={partners}
          handleAddAnother={handleAddAnother}
          addAnother={addAnother}
          loading={loading}
        />
      )}
      <MUIDataTable
        title={
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              handleButtonClick(`Add`);
            }}
            startIcon={<AddCircleIcon />}
          >
            New User
          </Button>
        }
        data={allUsers}
        columns={columns}
        options={options}
      />
    </div>
  );
};
export default Users;
